import 'core-js/stable';
import 'regenerator-runtime/runtime';

/**
 * Select auth from state (used with redux-saga/effects.select)
 * @param {Object} state current state
 */
export const authSelector = (state) => state.auth;
